module.exports = __webpack_public_path__ + "static/img/logo-en.5dc6045a.png";